import React from 'react';
import { SwipeableProps, useSwipeable } from 'react-swipeable';

export type SupportsSwipingProps = Pick<React.HTMLAttributes<HTMLElement>, 'onMouseDown'> & {
    swipeableRef: (element: HTMLElement) => void,
}

const withSwipeable = <P extends SupportsSwipingProps>(Component: React.ComponentType<P>, swipeableProps: SwipeableProps): React.ComponentType<Omit<P, 'onMouseDown'>> => {
    return (props) => {
        const {onMouseDown, ref} = useSwipeable(swipeableProps)

        return <Component {...props as any} onMouseDown={onMouseDown} swipeableRef={ref}/>
    }
}

export default withSwipeable;